import { hydrate } from "@propublica/pp-svelte/util/hydrate-baker.mjs";

import { CountyMap, MapLegend2 } from "./svelte-components.js";
import AreaChart from "./AreaChart.svelte";
import CompareCharts from "./CompareCharts.svelte";

const HOME_PATH = process.env.PATH_PREFIX;
const INSTITUTION_PREFIX = HOME_PATH + "institution/";
const TRIBE_PREFIX = HOME_PATH + "tribe/";

const currentPath = function normalizeCurrentPath() {
    let result = window.location.pathname;
    if (!result.endsWith("/")) result += "/";
    return result;
};

/**
 * @typedef {Object} PageContext Signals how charts render on different pages
 * @property {"homepage" | "institution" | "tribe" } type
 * @property {string} slug
 */

/**
 * @returns {PageContext}
 */
const pageContext = function currentPageContext() {
    const path = currentPath();
    if (path === HOME_PATH) {
        return { type: "homepage", slug: HOME_PATH };
    } else if (path.startsWith(INSTITUTION_PREFIX)) {
        let slug = path.slice(INSTITUTION_PREFIX.length, -1);
        return { type: "institution", slug: slug };
    } else if (path.startsWith(TRIBE_PREFIX)) {
        let slug = path.slice(TRIBE_PREFIX.length, -1);
        return { type: "tribe", slug: slug };
    }
    throw new Error(`Tried to get page context on invalid path: ${path}`);
};

/**
 * @param {PageContext} ctx
 */
const drawAreaChart = async function (ctx) {
    const chartTarget = document.querySelector("#stack-chart");

    // If target doesn't exist, stop here.
    if (!chartTarget) return;

    new AreaChart({
        target: chartTarget,
        props: { ctx },
    });
};

/**
 * @param {PageContext} ctx
 */
const drawCompareCharts = async function (ctx) {
    const chartTarget = document.querySelector("#compare-container");

    if (!chartTarget) return;
    new CompareCharts({
        target: chartTarget,
        props: { ctx },
    });
};

const ctx = pageContext();
// @ts-ignore (TODO(@alecglassford): Fix type problems with componentClasses)
hydrate({ CountyMap, MapLegend2 });
drawAreaChart(ctx);
drawCompareCharts(ctx);
